import { scrollByClamped } from '../scrollByClamped/scrollByClamped';

/**
 * Horizontally scrolls a scroll-container so the given child tab sits centred
 * in the container's viewport, clamped to the container's scroll range so the
 * first/last tabs rest flush with their edge instead (see scrollByClamped for
 * why the clamp is essential on iOS Safari).
 *
 * Centring rather than edge-aligning matters because the tab strips overlay
 * fade hints and arrow controls on their edges (horizontal-scroll-hint /
 * HorizontalScrollControls): a tab nudged merely "into view" lands flush under
 * that overlay and reads as half-hidden while the scroll-spy walks through
 * sections.
 *
 * Deliberately avoids Element.scrollIntoView: that also scrolls ancestor
 * scroll containers, moving the whole page. Operating on the container's own
 * scrollLeft keeps the effect local.
 */
export const scrollTabIntoView = (
	container: HTMLElement | undefined | null,
	tab: HTMLElement | undefined | null
) => {
	if (!container || !tab) return;

	const containerRect = container.getBoundingClientRect();
	const tabRect = tab.getBoundingClientRect();

	const delta =
		(tabRect.left + tabRect.right) / 2 -
		(containerRect.left + containerRect.right) / 2;

	scrollByClamped(container, delta);
};
